import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/components/atoms/LinkButton/LinkStrapi';

type Props = {
  button: LinkButtonStrapiProps;
  isCardFullWidth?: boolean;
};

export default function ProductCardButton({
  button,
  isCardFullWidth = false,
}: Props) {
  return (
    <div
      className={isCardFullWidth ? 'mt-8' : 'w-full mt-auto'}
      data-tracker-component='action-button'
    >
      <LinkButtonStrapi
        block={button}
        inner={{
          variant: button.variant || 'filled',
          color: button.color || 'primary',
          fullwidth: !isCardFullWidth,
          classNames: {
            root: isCardFullWidth ? 'w-full md:w-auto' : undefined,
          },
        }}
      />
    </div>
  );
}
